import {spotheroGet} from 'api';
import {sendSentryException} from 'utils/error-handling';
import {type SelectInputOptions} from 'common/common.types';
import {type FacilityFilterOptions} from 'api/facilities/facilities.types';

interface GetFilterOptionsFormattedResponse {
    cities: SelectInputOptions[];
    status: SelectInputOptions[];
}

/**
 * Formats the response from the Get Filter Options endpoint
 *
 * @group DTO Formatters
 */
export const formatFilterOptionsResponse = (
    data: FacilityFilterOptions
): GetFilterOptionsFormattedResponse => {
    // normalize cities in the format of {label: `${city}, ${state}`, value: `${city}, ${state}`}
    const normalizedCities = data?.cities?.map((city) => ({
        label: `${city.city}, ${city.state}`,
        value: `${city.city}, ${city.state}`,
    }));

    const normalizedStatus = data?.status?.map((status) => ({
        label: status,
        value: status,
    }));

    return {
        cities: normalizedCities,
        status: normalizedStatus,
    };
};

/**
 * This function is used to get facility filter options
 *
 * @returns The formatted response from the mockOperatorAPIService.
 * @throws {Error}
 *
 * @see '/api/v1/facilities/operator-facility-search/filter-options/'
 */
const getFilterOptions = async () => {
    try {
        const response = await spotheroGet<FacilityFilterOptions>(
            '/facilities/operator-facility-search/filter-options/'
        );

        const formattedResponse = formatFilterOptionsResponse(
            response.data.data
        );

        return formattedResponse;
    } catch (error) {
        sendSentryException(error);

        throw Error(error);
    }
};

export default getFilterOptions;
